module.exports = __webpack_public_path__ + "68ed1dac06bf0409c18ae7bc62889170.woff";


//////////////////
// WEBPACK FOOTER
// ../fonts/bootstrap/glyphicons-halflings-regular.woff
// module id = 2767
// module chunks = 69